import { Component, Input } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatIconButton } from '@angular/material/button'
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu'
import { NgForOf, NgIf } from '@angular/common'
import { MatTooltip } from '@angular/material/tooltip'
import { LanguageLocale, LocaleId, LocaleService } from 'shared-services'

@Component({
  selector: 'sans-language-icon',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    NgForOf,
    MatTooltip,
    MatMenuTrigger,
    NgIf,
  ],
  templateUrl: './language-icon.component.html',
  styleUrl: './language-icon.component.css',
})
export class LanguageIconComponent {
  @Input() public isHamburgerMenuItem = false

  public languageTooltipLabel = $localize`:Tooltip label|LanguageIconComponent:Choose language`
  public switchLanguageLabel = $localize`:Label|LanguageIconComponent:Switch language`

  public languageLocales = this.localeService.languageLocales

  constructor(private localeService: LocaleService) {}

  public languageLocaleTrackBy(_: number, languageLocale: LanguageLocale): LocaleId {
    return languageLocale.localeId
  }

  public onSetLanguageLocale(languageLocale: LanguageLocale): void {
    this.localeService.setLanguageLocale(languageLocale)
    this.localeService.reload(languageLocale)
  }
}
